import { Z2HLayout } from "layouts";
import { Section, Container, Z2HMenu, Wistia } from "components";
import Link from "next/link";
import Image from "next/legacy/image";
import Head from "next/head";
import * as cx from "classnames/bind";
import s from "styles/Z2H.module.scss";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";

export default function Contact({ policies }) {
  const { t } = useTranslation();
  return (
    <>
      <Head>
        <title key="title">Ice scoop - Zero to hero - Cocktail Club</title>
        <meta
          key="ogTitle"
          property="og:title"
          content="Ice scoop - Zero to hero - Cocktail Club"
        />
        <meta
          key="ogUrl"
          property="og:url"
          content="https://cocktailclub.com/z2h/Ice scoop"
        />
        <link
          key="canonical"
          rel="canonical"
          href="https://cocktailclub.com/z2h/ice-scoop"
        />
      </Head>
      <Z2HLayout>
        <Section>
          <Container>
            <Z2HMenu />
            <div className={cx(s.Z2HContent)}>
              <h1 className="Heading__main">{t("Ice scoop - Zero to hero")}</h1>
              <p>
                Using an ice scoop when making a cocktail helps consistent
                portioning. It can also maintain the correct dilution levels for
                a properly chilled, balanced serve.
                <br />
                <br />
                Cocktails that benefit from the use of an ice scoop include:
                <br />
                <Link href="/cocktails/mojito">• Mojito</Link>
                <br />
                <Link href="/cocktails/daiquire">• Daiquiri</Link>
                <br />
                <Link href="/cocktails/old-fashioned">• Old Fashioned</Link>
                <br />
                <Link href="/cocktails/margarita">• Margarita</Link>
                <br />
                <Link href="/cocktails/negroni">• Negroni</Link>
              </p>
              <br />
              <br />
              <h2 className="Heading__sub Bold">Introduction</h2>
              <div className={cx("videoDisplay", s.videoDisplay)}>
                <Wistia code="pyahfcsebs" size="56.25% 0 0 0" />
              </div>
              <h2 className="Heading__sub Bold">Getting started</h2>
              <div className={cx("videoDisplay", s.videoDisplay)}>
                <Wistia code="3qzazu69wg" size="56.25% 0 0 0" />
              </div>
            </div>
          </Container>
        </Section>
      </Z2HLayout>
    </>
  );
}

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale)),
  },
});
